import { render, staticRenderFns } from "./ProzessTextarea.vue?vue&type=template&id=683cdf2f&scoped=true"
import script from "./ProzessTextarea.vue?vue&type=script&lang=js"
export * from "./ProzessTextarea.vue?vue&type=script&lang=js"
import style0 from "./ProzessTextarea.vue?vue&type=style&index=0&id=683cdf2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683cdf2f",
  null
  
)

export default component.exports